import React, { useState } from "react";
import { Options } from "../../../Layout/Shared/DropdownOptionsMenu";
import { ThreeDotIcon } from "../../../../assets/icons/icon";
import { DeleteModal } from "../../../Layout/Shared/Popups/Delete";
import { deleteStage } from "../../../../data/CaseManagement/stages";
import { useHistory } from "react-router-dom";

export const ActionButtons = ({ stage, refresh }) => {
  const history = useHistory();
  const [showDelete, setShowDelete] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleDelete = async () => {
    setSubmitting(true);
    const { hasSuccess } = await deleteStage(stage._id);
    if (hasSuccess) {
      await refresh();
      setShowDelete(false);
    }
    setSubmitting(false);
  };

  const handleView = () =>
    history.push(`/business/case-management/cases/form/${stage._id}/view`);
  const handleEdit = () =>
    history.push(`/business/case-management/cases/form/${stage._id}/edit`);

  return (
    <>
      {submitting ? (
        <span className="dots-loading">{ThreeDotIcon}</span>
      ) : (
        <Options
          arrow={false}
          buttonTitle={ThreeDotIcon}
          menuItems={
            <div>
              <button onClick={handleView}>View</button>
              <button onClick={handleEdit}>Edit</button>

              <button
                className="text-danger"
                onClick={() => {
                  setShowDelete(true);
                }}
              >
                Delete
              </button>
            </div>
          }
        />
      )}

      {showDelete && (
        <DeleteModal
          title="Delete Stage"
          text="You are about to delete this stage from your stage list. Deleting
          this stage removes all stage’s information and ends all previous
          communication between you and the stage."
          buttonText="Delete"
          onConfirm={handleDelete}
          onClose={() => setShowDelete(false)}
        />
      )}
    </>
  );
};
